import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#485062",
      200: "#485062",
      300: "#485062",
      400: "#485062",
      500: "#485062",
      600: "#485062"
    },
    secondary: {
      100: "#CFC493",
      200: "#8A8A8A",
      300: "#485062"
    },
    background: {
      100: "#CBD1D6",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#CBD1D6"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#00B0B9",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    viewMenuHover: "#485062",
    outletLocationRestText: "#485062",
    orderOnlineHomeButton: "#485062",
    errorModalHeaderBg: "#CBD1D6",
    circularAddBtn: "#474F61",
    locationListBtn: "#474F61",
    timeDropDownBg: "#FFFFFF",
    modalLightBg: "#E9EAEC",
    secondary200Mobile: "#8A8A8A",
    modalDarkBg: "#FFFFFF",
    startBgColor: "#E9EAEC",
    confirmationModalOptionBg: "#CBD1D6",
    asapOptionBg: "#CBD1D6",
    asapTextColor: "#404040",
    selectedCarouselItemWithoutImage: "white",
    unselectedCarouselItemWithoutImage: "#ffff",
    checkoutButtonBackgroundColor: "#474F61",
    menuItemCardBg: "#CBD1D6",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "#E9E9E9",
    menuItemCardBorder: "transparent",
    selectedMenuCategoryBorder: "#485062",
    themeErrorColor: "#F5D6D8",
    themeErrorTextColor: "#CD3838",
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#B1B7BB",
    listItemDivider: "transparent",
    categoryBoxDivider: "#485062",
    categoryBoxTop: "#B1B7BB",
    categoryBoxBottom: "#B1B7BB",
    firstCategoryBoxDivider: "transparent",
    themeSectionSeparatorDark: "#979797",
    themeSectionTextDark: "#8A8A8A",
    infoLinkColor: "#485062",
    backLinkColor: "#485062",
    themeTextColor: "#212529",
    legalDesclaimerText: "#212529",
    themeGrey: "#606060",
    refreshIconColor: "#485062",
    headerBackground: "#292C33",
    themeDarkGrey: "#2E2A26",
    orderSettingsDateTimeChoiceColor: "#C16436",
    selectedOptionBorderColor: "#C16436",
    menuDetailsMobileHeaderText: "#C16436",
    configOptionsAccordionBackground: "#485062",
    hStackArrowsColor: "#485062",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#C16436",
    categoryHeaderSeparator: "#EAEAEA",
    bannerDropShadow: "rgb(0,0,0)",
    categoryNavBgColor: "#E9EAEC",
    btnHoverColor: "#292D36",
    waitlistRestaurantInfoBoxText: "#54301A",
    menuListTooltipBg: "#485062",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#485062",
    menuDetailTooltipColor: "#FFFFFF",
    downArrowColor: "#020001",
    menuItemNameColor: "#332C28",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#606060",
    specialInstArrowColor: "black",
    cartNoOfItemsText: "#cbd1d6",
    cartItemPrice: "#485062",
    cartNumberText: "#485062",
    cartPhoneNumber: "#212529",
    mobileBg: "#FFFFFF",
    cartItemActionBtn: "#485062",
    cartHeaderOrderType: "#485062",
    cartHeaderLocationName: "#485062",
    menuItemAddButtonColor: "#292D36",
    // Newly added token names from other brand theme (OG && LH)
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#ABABAB",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    deliveryModalNameColor: "#A2402A",
    sliderItemColor: "#C26435",
    headerBackgroundTop: "#292D36",
    // Menu Listing
    menuButtonBackgroundColor: "#474F61",
    orderSettingsTextColor: "#485062",
    categoriesText: "#485062",
    mobilePayHeaderBtnBorder: "#485062",
    modalCategoriesText: "#485062",
    inActiveCategoriesText: "#606060",
    inActiveModalCategoriesText: "#606060",
    menuItemPriceColor: "#332C28",
    menuItemCalorieColor: "#332C28",
    scrollToTopColor: "#485062  ",
    itemAddToCartPopupBackground: "#485062",
    recommendationaInfoTextColor: "#020001",
    reorderInfoTextColor: "#332C28",
    reorderHeadingsText: "#020001",
    // Menu Details
    orderInfoBg: "#E9EAEC",
    specialInstInputBg: "#E9EAEC",
    notSelectedOptionBorderColor: "#D7D7D7",
    sliderWithButtonsBackground: "#474F61",
    recommendationHeadingColor: "#020001",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    menuDetailAccordionDownArrowColor: "#FFFFFF",
    menuDetailAccordionTextColor: "#FFFFFF",
    menuDetailsAccordionDetailsBackground: "#F7F7F7",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#FFFFFF",
    menuDetailModifyOrRemoveColor: "#020001",
    menuDetailTemparatureSliderLabelColor: "#303030",
    menuDetailItemNameColor: "#020001",
    legalDisclaimerText: "#212529",
    menuDetailsItemPriceColor: "#020001",
    menuDetailsItemDescriptionColor: "#020001",
    menuDetailsItemCaloriesCaolor: "#020001",
    menuDetailsModifiersBorderColor: "#485062 ",
    menuDetailsBackToMenu: "#485062",
    menuDetailsSliderItemBackground: "#EBE9E9",
    menuDetailsSliderHoverColor: "#485062",
    loginModalTextColor: "#485062",
    requiredTextColor: "#C26435",
    nutritionalHTMLColor: "#020001",
    // Menu Details END
    orderConfirmationTextColor: "#3D3D3D",
    globalBannerBg: "#202228",
    locationListingItemText: "#020001",
    locationListingItemHeading: "#020001",
    locationListingItemHeadingMobile: "#485062",
    confirmPickupDetailsText: "#485062",
    addressTextColor: "#303030",
    itemIsFor: "#606060",
    itemIsForName: "#332C28",
    cartItemTitle: "#212529",
    specialInstructions: "#332C28",
    cartItemOption: "#8A8A8A",
    locationsNear: "black",
    searchResultsName: "#303030",
    ninjaIconColor: "#51689C",
    plusIconColor: "#485062",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    locationConfirmationHeadings: "#C16436",
    orderSettingsDesktop: "#020001",
    orderSettingsMobile: "#332C28",
    previousOrderItemStatus: "#485062",
    accordionDescription: "white",
    skuUnavaliableTextColor: "#A2402C",
    youMightLikeBannerColor: "#485062",
    defaultMenuBannerBg: "#2f2f2f",
    defaultMenuTextColor: "white",
    newIndicatorBannerColor: "#00B0B9",
    quantityArrowColor: "#485062",
    textCTAColor: "#485062",
    orderSettingsDivider: "#ABABAB",
    orderSettingsDividerMobile: "#ABABAB",
    orderSettingsBorder: "#ABABAB",
    categoryBoxTopMobile: "transparent",
    categoryBoxBottomMobile: "transparent",
    emptyCartHeaderBgColor: "#D8DCE0",
    modalTextColor: "#212529",
    selectedListItem: "#CBD1D6",
    reOrderAddBtnBorder: "#485062",
    locationListItemBorder: "transparent",
    allLocationsSelectBgMobile: "#CBD1D6",
    allLocationsSelectBgDesktop: "#E9EAEC",
    locationCardBg: "#E9EAEC",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#CBD1D6",
    allLocationsBodyBgDesktop: "#CBD1D6",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#485062",
    checkoutBorderColor: "transparent",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    categoriesHeadingColor: "#212529",
    categoriesDescriptionColor: "#212529",
    itemUnavailableCardBg: "#E9EAEC",
    itemCardBg: "#E9EAEC",
    itemCardBgLight: "#E9EAEC",
    // ORDER CONFIRMATION START
    orderConfirmationBackground: "#CBD1D6",
    orderConfirmationCustomerEmail: "#303030",
    confirmationPrimary: "#292D36",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#485062",
    confirmationAccentDark: "#212529",
    confirmationCheckbox: "#485062",
    hStackArrowsBg: "#cbd1d6d9",
    confirmationThemeDark: "#020001",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "#E9EAEC",
    confirmationSpecialInstructionsBg: "#E9EAEC",
    // ORDER CONFIRMATION END
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    bodyBg: "#CBD1D6",
    quickAddModalBg: "#CBD1D6",
    cardColor: "#E9EAEC",
    menuInfoBackgroundMobile: "#E9EAEC",
    menuInfoBackgroundDesktop: "#E9EAEC",
    selectedSKUItem: "#CBD1D6",
    configOptionBg: "white",
    nonSelectedSkuItem: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#474F61",
    selectedDescriptionText: "#FFFFFF",
    carouselBorderColor: "#B1B7BB",
    signInTextColor: "#212529",
    registerTextColor: "#212529",
    recommendationsHeadingColor: "#212529",
    capacityInfoText: "#606060",
    selectedStateColor: "#000000",
    quantityColor: "#212529",
    timeDropdownColor: "#000000",
    searchKeywordHighlightColor: "#292C33",
    //Menu search
    suggestedSearchTextColor: "#303030",
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalBackgroundColor: "#CBD1D6",
    menuSearchModalDivider: "#ABABAB",
    inputFieldBackgroundColor: "#F6F6F6",
    searchCardCategorySlugColor: "#808080",
    searchModalCategoryListBg: " #E9EAEC",
    searchIconContainerBgColor: "#485062",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    paymentOrderTotalTextColor: "#000000",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#A1784D",
    profileHeaderLinearGradientEndColor: "#6A4A27",
    profileAddCardButtonText: "#fff",
    searchBarBorderColor: "#D6D6D6",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    mobilePayConfirmationScreenBlockBG: "#E8EAEC",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#485062",
    reservationUnSelectedCTABorderColor: "transparent",
    reservationSelectedCTABGColor: "#E9EAEC",
    reservationUnSelectedCTABGColor: "#E9EAEC",
    reservationPopupBgColor: "#E9EAEC",
    locationsTopTabsContainerColor: "#FFFFFF",
    searchItemCardTextColor: "#505050",
    noResultTextColor: "#292C33",
    menuSearchBarContainerBg: "#9EAEC",
    searchItemBreadCrumbSlugcolor: "#666666",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#000000",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    menuSearchModalCloseIconBg: "#CBD1D6",

    /* Restaurant Details */
    restaurantDetailsBGColor: "#CBD1D6",
    restaurantDetailsDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#292D36",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#8F278A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#B7BEC5",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#EC008C",
    restaurantDetailsNotSelectedWeekDayTextColor: "#404040",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restDetailsRestInfoTitleColor: "#2A2C25",
    restaurantInfoAddressTextColor: "#2A2C25",
    restaurantInfoNumberAndDistanceTextColor: "#2A2C25",
    restaurantInfoAddToFavouritiesTextColor: "#2A2C25",
    restaurantTimingWeekDayTextColor: "#51689C",
    restaurantDetailsAmenetiesbgColor: "#CBD1D6",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantAboutSectionBodyTextSecColor: "#404040",
    restaurantHoursTextColor: "#2A2C25",
    restaurantTimingsTextColor: "#2A2C25",
    amenitiesHeadingColor: "#2A2C25",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    amenitiesActionButtonsColor: "#2A2C25",
    orderFromHereButtonTextColor: "#292D36",
    restaurantNumberAndDistanceDividerColor: "#2A2C25",
    restaurantAboutSectionHeadingTextColor: "#2A2C25",
    restaurantAboutSectionBodyTextColor: "#404040",
    politeNoticeBoxBg: "#C1C9CF",
    politeNoticeBoxBgMobile: "#CBD1D6",
    scrollToTopBgColor: "#C1C9CF",
    scrollToTopBgColorMobile: "#CBD1D6",

    /* Restaurant Details End*/

    /* Order Tracking start*/
    orderStatusText: "#485062",
    orderStatusCircleBg: "#79818C",
    locaionAndTimeHeaderBg: "#E9EAEC",
    locaionAndTimeHeaderBorder: "#79818C",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#485062",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#485062",
    orderStatusSectionBg: "#E9EAEC",
    refreshButtonColor: "#485062",
    checkText: "#2A2C25",
    curbsideCheckInAvailable: "#79818C",
    orderStatusSectionBorderColor: "#79818C",
    refreshButtonBg: "#FFFFFF",

    /* Order Tracking end*/
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#C16436",
    imageStackBorderColor: "#FFFFFF",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#D6DCD2",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    noOfGuestsLabelColor: "#808080",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#C16436",
    homescreenLocationTextColor: "#303030",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#485062",
    searchThisAreaBg: "#485062",
    locationSearchInActiveTab: "#606060",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#292D36",
    allLocationsLsBg: "#B7BEC5",
    callRestLsText: "#485062",
    mobilePayICheckError: "#3F3C3C",
    locationListingItemHeadingInPage: "#485062",
    locationSearchTabDivider: "#00000026",
    locationSearchTabBgColor: "transparent",
    lsAllLocationsSelectBorder: "#00000026",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    allLocationsLSPageBg: "#CBD1D6",
    locationSearchAddressColor: "#303030",
    allLocationsPageItemBoxBorderColor: "#48506233",
    locationsSearchPageLocationListItemBgColor: "transparent",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#485062",
    hoursInfoAccordionTitle: "#EC008C",
    newLoctionsLinkText: "white",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#485062",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    addCreditCard_headerBackgroundColor: "#FFFFFF",
    editProfileInfoCardBg: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#8A8A8A",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    newLocationsBannerBg: "#292C33",
    recentOrderBorder: "#CBD1D6",
    pickupDetailsBorder: "#B1B7BB",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#CBD1D6",
    reorderAddItemBg: "#485062",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#8A8A8A",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#8A8A8A",
    orderHistoryCardLayoutBackgroundColor: "#E9EAEC",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuListSkeletonHeaderContainerBackground: "#F8F8F8",
    menuListSkeletonHeaderBackground: "#FFF",
    menuListSkeletonCategoryNavigationBgColor: "#F8F8F8",
    menuListSkeletonTopTabActiveBottomBorderColor: "#485062",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#485062",
    selectedOrderTypeTextColor: "#485062",
    mobileCalendarTextColor: "#485062",
    gcBalanceRefreshBorderTextColor: "#485062",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    smartRecommendationModalCloseIconColor: "#737373",
    networkIndicatorColor: "black",
    calenderTodayBackgroundColor: "#73994A",
    calenderSelectedDayColor: "#73994A",
    calenderSelectedDayTextColor: "#000",
    calenderSelectedDayStyleBGColor: "#73994A",
    reserveTableHeaderRightButtonText: "#73994A",
    reserveConfirmationDescriptionHeaderBg: "#485062",
    reservationSelectedSeatingOption: "#CBD1D6",
    reservationCalendarCtaBorderRadius: 0,
    reservationDOBMonthBgColor: "#fff",
    reservationDOBNavColor: "primary.100",
    reservationDOBYearBgColor: "#fff",
    reservationInputErrorColor: "#DF4505",
    reservationLocationModalDeskHeaderBg: "#292C32",
    reservationLocationModalMobHeaderBg: "#292C32",
    reservationLocationListBg: "#CBD1D6",
    reservationLocationListBgMobile: "#CBD1D6",
    pdLocationListBg: "#CBD1D6",
    pdLocationListBgMobile: "#CBD1D6",
    outletLocationItemButtonText: "#FFF",
    reservationDropDownIconColor: "#020001",
    reservationsSpecialRequestSwitch: "#485062",
    reservationBg: "#CBD1D6",
    reservationStaticTextBg: "#E9EAEC",
    reservationTabsBg: "#292D36",
    reservationPickerHoverColor: "#E7EDF2",
    reservationNoOfGuestsSelectedBg: "#485062",
    reservationNoOfGuestsNotSelectedBg: "#E9EAEC",
    reservationsTimePickerBg: "#CBD1D6",
    reservationActionButtonsBg: "#E9EAEC",
    reservationInactiveSelectTime: "#CBD1D6",
    locationModalDividerColor: "#C6C6C6",
    mobileAppAuthBg: "#E9EAEC",
    smartRecommendationCardbg: "#E9EAEC",
    myReservationsBoxBg: "#E9EAEC",
    serveAsEntreeSwitch: "#485062",
    confirmationModalBorderRadius: 0,
    cancelConfirmationModalBorderRadius: 0,
    preferredLocationCloseButtonBg: "#485062",
    preferredLocationCloseButtonHover: "#485062",
    preferredLocationModalContentColor: "#CBD1D6",
    preferredLocationCloseButtonIconColor: "#FFFFFF",
    reservationHoveredText: "#485062",
    reservationNotHoveredText: "#485062",
    reservationsCardsBodyBg: "transparent",
    reservationsCardBg: "#E9EAEC",
    reservationSpecialRequests: "#E9EAEC",

    /** Colors: Private Dining Start */
    minimalHeaderSignInBtn: "#292C33",
    makeRequestPageBg: "#CBD1D6",
    requestFormTabActiveItem: "#C8D4ED",
    requestFormTabDisableItem: "#485062",
    splRequestToggleTrackColor: "#485062",
    pdPurposeDropDownOptionHover: "#485062",
    pdTimeDropDownOptionHover: "#485062",
    pdPartySizeRangeOptionHover: "#485062",
    pdmenuPrefOptionHover: "#485062",
    pdFooterPrivacyNotice: "#485062",
    pdContactDetailsEdit: "#485062",
    pdReviewDetailsEventInfoDivider: "#D8D8D8",
    pdConfirmationMobileBg: "#CBD1D6",
    pdRequestFormInputBg: "#E9EAEC",
    pdRequestFormInputBorder: "transparent",
    pdFooterBg: "#E9EAEC",
    pdActionSheetBody: "#E9EAEC",
    pdMobilePageBg: "#CBD1D6",
    eventPurposeSelectorColor: "#303030",
    eventPurposeSelectorHoverColor: "#FFFFFF",
    pdContactsPhoneTypeDivider: "#C1C1C1",
    pdFormAsteriskColor: "#485062",
    pdLandingMenuTabBg: "#B7BEC5",
    pdLandingLocationInfoMobileBg: "#B7BEC5",
    pdLandingDropdownActive: "#485062",
    pdLandingDropdownInActive: "#E9EAEC",
    pdLandingNoLocationContainer: "#CBD1D6",

    /** Colors: Private Dining End */
    reservationDOBTooltipTextColor: "#FFFFFF",
    reservationDOBTooltipBgColor: "#485062",
    myAccountGiftCardLargeBorderRadius: 0,
    eClubHoverActiveColor: "#F2EFEA",
    eClubHoverActiveTextColor: "#303030",
    eClubHoverInactiveTextColor: "#303030",
    eClub_background_color: "#CBD1D6",
    eClub_confirmation_background_color: "background.100",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#CBD1D6",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    lunchIssueModalSeparator: "#EBE9E9",
    desktopTopTabsBG: "#CBD1D6",
    menuSearchModalCloseIconColor: "black",
    menuSearchInputBorder: "primary.100",
    menuSearchResultContainerBG: "#fff",
    pdRequestFormBG: "#fff",
    modalHeaderColor: "#fff",
    modalHeaderTextColor: "#404040",
    editProfileFullBottomButtonBackgroundColor: "#E9EAEC",
    orderHistoryFullBottomButtonBackgroundColor: "#E9EAEC",
    orderHistoryDetailsHeaderModalBackgroundColor: "#292D36",
    pdInputDataTextColor: "#000",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    EClubInputErrorColor: "#DF4505",
    reservationSelectTimeTextColor: "#000",
    locationListBgColor: "#fff",
    locationsSearchPageLocationListItemBgColorMobile: "transparent",
    joinEclubContainerBgColor: "#CBD1D6",
    editProfile_modalHeaderBackgroundColor: "#E9EAEC",
    editProfile_modalBodyBackgroundColor: "#CBD1D6",
    confirmationModalCTABackgroundColor: "#485062",
    giftCardLargeBody_BackgroundColor: "#CBD1D6",
    giftCardLargeBody_webModalBackgroundColor: "#CBD1D6",
    giftCardLargeHeader_BackgroundColor: "#292D36",
    webOrderHistoryBackgroundColor: "#CBD1D6",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#E9EAEC",
    myAccountBgImageOverlay: "#CBD1D6",
    myAccountBgColor: "#B7BEC5",
    myAccountCardBackgroundActive: "#B8C0C7",
    myAccountCardBackground: "transparent",
    displayImageFallbackBackground: "#E0DFE0",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileAuthFooterActiveText: "#485062",
    myAccountChangeFieldModalBg: "#F5F0E6",
    profileScreenMainModalBackgroundColor: "#F5F0E7",
    showCreditCard_bottomSheet_BackgroundColor: "#292D36",
    addEditCreditCard_scrollView_backgroundColor: "#CBD1D6",
    mobileOrderHistoryBackgroundColor: "#CBD1D6",
    mobileMasterCardGradientFirst: "#2A0000",
    mobileMasterCardGradientSecond: "#1C338F",
    mobileMasterCardGradientThird: "#214792",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentsCardTextColor: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    addCreditDebitCardTooltipBgColor: "#686F7F",
    myAccountScreenBackroundColor: "#CBD1D6",
    myAccountScreenMobileBackgroundColor: "#CBD1D6",
    myAccountScreenWebBackgroundColor: "#CBD1D6",
    myAccountEditProfileScrollViewBg: "#CBD1D6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#B8C0C7",
    orderHistoryDetailsBGColor: "#CBD1D6",
    securityBannerTextColor: "#4F4F4F",
    addCreditDebitCardTooltipTextColor: "#FFFFFF",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#E9EAEC",
    orderHistoryModalHeaderTextColor: "#FFFFFF",
    orderHistoryDetailsModalBackgroundColor: "#CBD1D6",
    myAccountSkipConfirmationCTA: "#485062",
    paymentOptions_giftCard_balanceAmountColor: "#000000",
    joinEclubPreferredLocationButtonBorderColor: "#D6D6D6",
    joinEclubDOBTextColor: "#485062",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    EclubFormInputPlaceholderTextColor: "#C0C0C0",
    grey300: "#303030",
    mobilePaymentMethodIconBg: "#485062",
    menuItemcardVerticalImageBorderRadius: "xl",
    reservationShareIconText: "#485062",
    globalMessageBannerPadding: 1,
    errorDialogModalBorderRadius: 8,
    itemIsForBgColor: "#CBD1D6",
    locationListItemOrderText: "white",
    locationListItemOrderBg: "secondary.300",
    locationListItemOrderHoverBg: "secondary.300",
    locationListItemOrderPadding: 3,
    EclubDOBBottomBorderColor: "#B1B7BB",
    orderDetailsCartItemPrice: "#000000"
  },
  components: {
    Pressable: {
      variants: {
        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 0,
          px: 10,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        reservationConfBackHomeBtn: {
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 0,
          _ios: {
            radiusValue: 6
          },
          _android: {
            radiusValue: 6
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 0,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 0,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mb: 2,
          mr: 2,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          bg: "#E9EAEC",
          borderRadius: 0
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          alignItems: "center",
          justifyContent: "center"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
              py: 2
            },
            _android: {
              bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
              py: 2
            },
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "44px"
            },
            style: {
              background: disabled ? "#BCBCBC" : "linear-gradient(137.78deg, #292D36 21.41%, #414C62 50.06%, #292D36 77.4%)"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            style: {
              background: selectedDay ? "linear-gradient(137.78deg, #292D36 21.41%, #414C62 50.06%, #292D36 77.4%)" : "#FFFFFF"
            },
            _ios: {
              background: selectedDay ? "#292D36" : "restaurantDetailsNotSelectedWeekDayColor"
            },
            _android: {
              background: selectedDay ? "#292D36" : "restaurantDetailsNotSelectedWeekDayColor"
            },
            borderColor: selectedDay ? "#292D36" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref4) {
          var disabled = _ref4.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        locationListItemAddress: {
          pointerEvents: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref5) {
          var radiusValue = _ref5.radiusValue,
              topRadiusValue = _ref5.topRadiusValue,
              bottomRadiusValue = _ref5.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewCartBtnBorderRadius: {
          _ios: {
            borderRadius: 8
          },
          _android: {
            borderRadius: 8
          }
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        },

        /** Pressable: Private Dining Start */
        privateDiningLocationSelectionBtn: {
          borderRadius: 0,
          px: 10,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        privateDiningModalCancelCTA: {
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#485062",
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          w: "100%"
        },
        privateDiningModalConfirmCTA: {
          bg: "#485062",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 0,
          w: "100%",
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#485062"
        },
        pd_landing_menuTabs_Item: function pd_landing_menuTabs_Item(_ref6) {
          var isActive = _ref6.isActive;
          return {
            bg: isActive ? "#485062" : "transparent",
            px: isActive ? 6 : 0,
            py: isActive ? 1.5 : 0,
            borderRadius: 0
          };
        },
        pd_landing_noLocation_selectCTA: {
          bg: "#485062",
          mt: {
            base: 8,
            md: 12
          },
          py: 3.5,
          px: 24,
          width: {
            base: "100%",
            sm: "auto"
          }
        },
        editFieldsConfirmationModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {},
        editFieldsSuccessModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4
        },
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "#485062",
          mx: 5,
          _ios: {
            width: {
              base: "auto",
              md: "55%"
            }
          },
          _android: {
            width: {
              base: "auto",
              md: "55%"
            }
          }
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "secondary.300"
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref7) {
          var isActive = _ref7.isActive;
          return {
            borderRadius: 0,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "#E9EAEC",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        },

        /** Pressable: Private Dining End*/
        eClubStickySignUpDesktopPressable: {
          bg: "#485062",
          px: 4,
          py: 2,
          borderRadius: 0,
          w: "100%",
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          bg: "secondary.300",
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 0,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: function myAccount_paymentOptions_addGC_actionSheet_Add(_ref8) {
          var isDisabled = _ref8.isDisabled;
          return {
            my: 1,
            borderRadius: 0,
            width: "100%",
            backgroundColor: "#485062",
            opacity: isDisabled ? 0.5 : 1,
            flex: 1,
            ml: 2,
            _web: {
              // width: { base: "100%", md: "30%" },
              my: 0
            }
          };
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto"
        },
        myAccount_paymentOptions_checkBalanceCTA: {
          justifyContent: "center",
          alignItems: "center",
          marginY: 1,
          border: 1.5,
          borderColor: "#485062",
          borderRadius: 0,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        }
      }
    },
    Button: {
      baseStyle: {
        borderRadius: 0,
        _focusVisible: {
          style: {
            boxShadow: "none"
          }
        }
      },
      variants: {
        solid: {
          bg: "#474F61",
          _pressed: {
            bg: "#474F61"
          },
          _hover: {
            bg: "#292D36"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "transparent"
          }
        },
        camAccessBtn: {
          bg: "#474F61",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          borderRadius: 0,
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "#474F61",
          _pressed: {
            bg: "#474F61"
          },
          _hover: {
            bg: "#474F61"
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "white",
            fontWeight: "400",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#CBD1D6"
          },
          _pressed: {
            bg: "#CBD1D6"
          }
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "14px"
            },
            fontWeight: "400",
            color: "white",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "headingSecondary"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A2402A",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            marginTop: 5,
            borderRadius: borderRadiusValue || 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref10) {
          var borderRadiusValue = _ref10.borderRadiusValue;
          return {
            borderRadius: borderRadiusValue || 0,
            backgroundColor: "secondary.300",
            shadow: 9
          };
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref11) {
          var borderRadiusValue = _ref11.borderRadiusValue;
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            bg: "bodyBg",
            _text: {
              color: "secondary.300"
            }
          };
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 600,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "18px"
            }
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "#474F61",
          borderColor: "#474F61",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        menuButton: function menuButton(_ref12) {
          var isActive = _ref12.isActive,
              isMobile = _ref12.isMobile,
              isLongText = _ref12.isLongText;
          return {
            ml: isLongText && isMobile && 5,
            px: isMobile ? 6 : 9,
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            _web: {
              width: !isMobile && (isLongText ? "100%" : "117px"),
              borderRadius: 0
            },
            width: 32,
            borderRadius: 0,
            height: {
              base: 8,
              md: 9
            },
            _text: {
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px",
                fontSize: isMobile ? "12px" : "14px"
              },
              lineHeight: isMobile ? 4 : 6,
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "600",
              fontSize: isMobile ? "xs" : "sm",
              textTransform: "uppercase",
              fontFamily: "Montserrat-Regular"
            }
          };
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            padding: 0,
            borderRadius: 0,
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            bg: "locationListBtn",
            _hover: {
              bg: "locationListBtn"
            },
            _pressed: {
              bg: "locationListBtn"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            padding: 0,
            borderRadius: 0,
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        pillButton: function pillButton(_ref13) {
          var isActive = _ref13.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 0,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "primary.100",
            _text: {
              color: "primary.100"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "#474F61"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref14) {
          var isUnavailable = _ref14.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "#474F61",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "#474F61"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "#474F61"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "8px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: "none"
          };
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: 0
            }
          };
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        preorderDineIn: {
          backgroundColor: "#C16436"
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "#474F61"
          };
        },
        // LS tokens
        viewMenuBtn: {
          padding: 0,
          borderWidth: 1,
          borderColor: "secondary.300",
          _text: {
            color: "secondary.300",
            marginY: "11px",
            marginX: 6,
            fontSize: 13,
            fontWeight: 400,
            letterSpacing: -0.3,
            fontFamily: "body",
            lineHeight: 4
          }
        },
        viewMenuBtnExternalLink: function viewMenuBtnExternalLink(_ref15) {
          var isLocationSearch = _ref15.isLocationSearch,
              fromAllLocations = _ref15.fromAllLocations;
          return {
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              marginX: 6,
              fontSize: 13,
              fontWeight: 400,
              letterSpacing: -0.3,
              fontFamily: "body",
              lineHeight: 4
            },
            bg: isLocationSearch && fromAllLocations ? "transparent" : "secondary.300",
            _hover: {
              bgColor: "secondary.300",
              _text: {
                color: "white"
              }
            },
            _pressed: {
              bgColor: "secondary.300"
            }
          };
        },
        locationListItemButtonBorderRadius: 0,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pl: 38,
            pr: 38,
            py: 3,
            backgroundColor: "secondary.300",
            borderRadius: 0,
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref16) {
          var radiusValue = _ref16.radiusValue,
              topRadiusValue = _ref16.topRadiusValue,
              bottomRadiusValue = _ref16.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 8
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        joinWaitlist_Header_LoginButton: {
          _text: {
            fontSize: 14,
            color: "#FFFFFF",
            fontWeight: 400
          },
          borderColor: "#FFFFFF",
          borderRadius: 0,
          px: "17px",
          py: "10px",
          _web: {
            px: {
              base: "10px",
              lg: "17px"
            },
            py: {
              base: "6px",
              lg: "10px"
            }
          },
          _focus: {
            backgroundColor: "#000000"
          },
          bg: "transparent",
          borderWidth: 1
        },

        /** Button: Private Dining Start */
        pd_Header_LoginButton: function pd_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "#FFFFFF",
              fontWeight: 400,
              textTransform: "uppercase"
            },
            px: "17px",
            py: "10px"
          };
        },
        pd_request_eventDetails_confirmCTA: function pd_request_eventDetails_confirmCTA() {
          return {
            borderRadius: 0,
            backgroundColor: "#485062",
            padding: 0,
            marginTop: 4,
            marginX: 5,
            marginBottom: 3,
            h: 12,
            _text: {
              color: "white",
              letterSpacing: -0.5,
              fontWeight: "400",
              fontSize: 18,
              marginTop: 3,
              marginBottom: 3,
              lineHeight: 6,
              textAlign: "center",
              textTransform: "uppercase"
            },
            _pressed: {
              opacity: 0.8
            }
          };
        },
        pd_requestForm_Footer_cancalCTA: function pd_requestForm_Footer_cancalCTA() {
          return {
            bg: "none",
            border: 2,
            borderRadius: 0,
            borderColor: "#485062",
            _text: {
              fontSize: 16,
              color: "#485062"
            },
            _hover: {
              bg: "none"
            }
          };
        },
        pd_requestForm_Footer_ContinueCTA: function pd_requestForm_Footer_ContinueCTA() {
          return {
            px: 12,
            _text: {
              fontWeight: 400,
              fontSize: 16,
              color: "white"
            },
            bg: "#485062",
            borderRadius: 0
          };
        },
        pd_confirmation_backToHomeCTA: {
          bg: "none",
          border: 2,
          borderRadius: 0,
          borderColor: "#485062",
          px: 12,
          mt: {
            md: 5
          },
          _text: {
            fontSize: 16,
            color: "#485062",
            fontFamily: "Montserrat-Regular"
          },
          _hover: {
            bg: "none"
          }
        },
        pd_landing_stickyFooter_pdReqCTA: {
          py: 2.5,
          width: {
            base: "100%",
            md: "469px"
          },
          height: 12,
          bg: "#474F61"
        },
        confirmAndAddToCartButton: {
          bg: "#474F61",
          _pressed: {
            bg: "#474F61"
          },
          _hover: {
            bg: "#292D36"
          }
        },

        /** Button: Private Dining End */
        ErrorDialogOKButton: {
          bg: "#474F61",
          _pressed: {
            bg: "#474F61"
          },
          _hover: {
            bg: "#292D36"
          }
        },
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "#474F61",
          _pressed: {
            bg: "#474F61"
          },
          _hover: {
            bg: "#292D36"
          }
        },
        editProfileFullBottomButton: {
          borderRadius: 0
        },
        orderHistoryReorderFullBottomButton: {
          borderRadius: 0
        },
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "secondary.300",
          mx: "auto"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "secondary.300"
        },
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          bg: "transparent",
          borderColor: "secondary.300",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            letterSpacing: -0.5,
            fontWeight: 400,
            textAlign: "center",
            color: "addCardFooterButtonText"
          },
          bg: "secondary.300"
        },
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1,
          borderColor: "#485062",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "#485062"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _text: {
            py: 1
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {},
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 5,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 400
          },
          bg: "#FFFFFF"
        },
        previousOrderItemAddCta: {
          borderRadius: {
            base: "md",
            md: "lg"
          },
          bg: "white",
          borderColor: "reOrderAddBtnBorder",
          borderWidth: 1
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref17) {
          var isMandatory = _ref17.isMandatory;
          return {
            borderRadius: 0
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: 0
          };
        }
      }
    },
    ModalContent: {
      baseStyle: {
        rounded: 0
      },
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref18) {
          var radiusValue = _ref18.radiusValue,
              topRadiusValue = _ref18.topRadiusValue,
              bottomRadiusValue = _ref18.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        pd_cancelModal: {
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "335px",
          py: 8,
          px: 6,
          backgroundColor: "#E9EAEC",
          borderRadius: 0
        },
        editFieldsConfirmationModal: {
          borderRadius: 0,
          p: 12
        },
        editFieldsSuccessModal: {
          borderRadius: 0,
          p: 12,
          maxWidth: {
            md: "588"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 0
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 12
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 0
        }
      }
    },
    ModalBody: {
      variants: {
        smartRecommendationModalModalBody: {
          _ios: {
            width: "100%"
          },
          _android: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          borderRadius: 0,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 0,
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref19) {
          var isMandatory = _ref19.isMandatory;
          return {
            borderTopRadius: 0
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref20) {
          var isMandatory = _ref20.isMandatory;
          return {
            borderBottomRadius: 0
          };
        },
        menuItemDetails: function menuItemDetails(_ref21) {
          var isDefaultExpanded = _ref21.isDefaultExpanded;
          return {
            borderBottomRadius: isDefaultExpanded ? 0 : undefined
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 0
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        },

        /** Stack: Private Dining Start */
        pd_landing_stickyFooter_container: {
          direction: {
            base: "column-reverse",
            lg: "row"
          },
          bgColor: "#E9EAEC",
          alignItems: "center",
          justifyContent: "space-between",
          py: {
            base: 3,
            md: 7
          },
          px: {
            base: 5,
            md: 32
          },
          shadow: {
            base: 14,
            md: 0
          }
        }
        /** Stack: Private Dining End */

      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Montserrat-Regular"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 0
        },
        borderRadiusValue: function borderRadiusValue(_ref22) {
          var radiusValue = _ref22.radiusValue,
              topRadiusValue = _ref22.topRadiusValue,
              bottomRadiusValue = _ref22.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },

        /** Input: Private Dining Start */
        pd_request_eventDetails_noOfGuestinput: {
          borderRadius: 0,
          fontFamily: "Montserrat-Regular"
        },
        pd_request_eventDetails_SplRequest: {
          borderRadius: 0
        },
        pd_request_contactDetails_input: {
          borderRadius: 0,
          fontFamily: "Montserrat-Regular"
        },

        /** Input: Private Dining End */
        myAccountInputForm: {
          fontFamily: "Montserrat-Regular"
        }
      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 3.5,
          w: 0.4
        }
      }
    },
    Text: {
      variants: {
        myAccount_button_editConfirmation_text: {
          fontWeight: 400
        },
        myAccount_button_cta_weight: 400,
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },

        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 18,
          fontWeight: 800,
          pb: 4,
          color: "#485062"
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          color: "#303030",
          fontWeight: 400,
          textAlign: "center"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 400,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "white",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 200,
          lineHeight: 5,
          textAlign: "center"
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#FFFFFF"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#FFFFFF"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "#FFFFFF"
          };
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "300",
          fontSize: 12,
          lineHeight: 4
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 500,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 500
        },
        reservationListCardDirections: {
          fontWeight: 700,
          lineHeight: 12,
          color: "primary.100",
          fontSize: 12
        },
        reservationListCardLocationText: {
          fontWeight: 400,
          fontSize: 11,
          color: "#303030",
          lineHeight: 5
        },
        reservationListCardRestName: {
          fontWeight: 500,
          fontSize: 12,
          color: "#020001",
          lineHeight: 5
        },
        reservationListCardRestAddress: {
          fontSize: 12,
          fontWeight: 400,
          color: "#303030",
          lineHeight: 5
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 600
        },
        reservationsReviewReservationsText: {
          fontWeight: 600
        },
        reservationsChangeLocationChangeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 600,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 600,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          fontWeight: 200
        },
        reservationLocationCardHeader: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        reservationLocationModalHeaderText: {
          color: "#FFF",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#020001",
          fontWeight: 300,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref23) {
          var isActive = _ref23.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#000" : "#FFF",
            fontSize: {
              base: 18,
              md: 20
            },
            mt: 2
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: 16,
          fontWeight: 500,
          lineHeight: 5,
          color: "grey300"
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: 12,
          color: "#707070",
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 12,
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 5,
          color: "grey300"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        OnboardingScreenTitleTextColor: {
          color: "secondary200Mobile",
          fontWeight: "500"
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        checkSummaryTitle: {
          fontSize: 22,
          color: "secondary200Mobile",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 5
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "orderTotalTextColor"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "#55111E"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        emailReceiptText: {
          fontSize: 20,
          lineHeight: 5,
          fontWeight: 500,
          fontFamily: "headingSecondary",
          color: "#55111E"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 10,
          color: "themeGrey",
          lineHeight: 3
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary200Mobile"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#485062",
            lg: "#485062"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#54301A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#54301A"
        },
        jwcTitle: {
          textAlign: "center",
          mt: 6,
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A"
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A2402A",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        checkinSuccessNoteTitleText: {
          color: "#FFFFFF",
          pt: 3,
          fontSize: 22,
          lineHeight: 42,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        checkinSuccessNoteBodyText: {
          color: "#FFFFFF",
          pt: 1,
          maxWidth: 173,
          textAlign: "center",
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        quantityNumber: {
          fontFamily: "Montserrat-Bold"
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        unavailableTextWeight: {
          fontWeight: 500
        },
        startingAtPrice: {
          color: "#212529",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "#212529",
          fontSize: 16,
          fontWeight: 500
        },
        categoryText: function categoryText(_ref24) {
          var isActive = _ref24.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          fontSize: "xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "26px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          _web: {
            fontSize: "26px"
          },
          fontSize: "xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        addBtnText: function addBtnText(_ref25) {
          var addButtonText = _ref25.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : 14,
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            fontFamily: "heading"
          };
        },
        nutritinalInfo: {
          _web: {
            fontSize: "18px"
          },
          fontWeight: 400
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 100,
            color: "#b3c3d4",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 500,
            fontFamily: "heading"
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 500,
            fontFamily: "heading"
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref26) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref26.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 500,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            fontSize: [24, 24, 32],
            fontWeight: 400,
            fontFamily: "headingSecondary"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            // mocks needs for values
            fontSize: [20, 20, 24],
            fontFamily: "headingSecondary",
            fontWeight: 400
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            fontSize: [16, 16, 20],
            color: "themeTextColor"
          };
        },
        locationText: {
          color: "white",
          fontSize: "14px",
          fontFamily: "headingSecondary"
        },
        phoneNumberText: {
          color: "white",
          fontSize: "xs",
          fontFamily: "body",
          fontWeight: "300"
        },
        btnText: {
          color: "white",
          fontFamily: "headingSecondary",
          _web: {
            fontSize: "14px"
          }
        },
        headerText: {
          color: "white"
        },
        cartItemCancelText: {
          fontSize: "xs",
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 500
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 600,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 600,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: 25,
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            _web: {
              fontSize: {
                base: "20px",
                md: "32px"
              }
            },
            fontFamily: "headingSecondary",
            fontWeight: 500
          };
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref27) {
          var isMandatory = _ref27.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "16px",
                md: "24px"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            textTransform: "uppercase",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref28) {
          var isMandatory = _ref28.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "16px",
                md: "24px"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textTransform: "uppercase",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref29) {
          var isMobile = _ref29.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref30) {
          var isMandatory = _ref30.isMandatory,
              isDefaultExpanded = _ref30.isDefaultExpanded;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 300,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            color: isDefaultExpanded ? "white" : "selectedDescriptionText"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "#CD3838",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#CD3838",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        confirmPickupDetailsHeaderText: function confirmPickupDetailsHeaderText() {
          return {
            fontFamily: "headingSecondary",
            fontSize: 20,
            fontWeight: 600,
            color: "#474F61",
            textTransform: "uppercase",
            lineHeight: 6
          };
        },
        confirmPickupDetailsRestaurant: function confirmPickupDetailsRestaurant() {
          return {
            fontFamily: "heading",
            fontSize: 16,
            lineHeight: 5,
            fontWeight: 500
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 500,
            lineHeight: 4,
            fontSize: 14,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 13,
            fontWeight: 500,
            color: "orderConfirmationTextColor"
          };
        },
        cartItemMenuName: function cartItemMenuName() {
          return {
            fontSize: 17,
            lineHeight: 5,
            _web: {
              letterSpacing: "-0.3px",
              width: {
                base: "164px"
              }
            },
            letterSpacing: "-0.3",
            width: {
              base: 40
            },
            fontWeight: 600,
            color: "menuItemNameColor"
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xs",
            _web: {
              pt: 2
            }
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName() {
          return {
            fontSize: 15,
            lineHeight: 5,
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px",
              width: "176px"
            },
            letterSpacing: "-0.3",
            width: 40,
            noOfLines: 3,
            color: "menuItemNameColor"
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "400",
            fontFamily: "headingSecondary",
            fontSize: "sm"
          };
        },
        menuItemInfoPrice: function menuItemInfoPrice() {
          return {
            fontFamily: "headingSecondary",
            fontWeight: 500,
            _web: {
              fontSize: {
                base: "20px",
                md: "32px"
              }
            } // fontSize: { base: 3, md: 4 },

          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "20px",
                md: "32px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 14
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 300,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        menuItemPrice: function menuItemPrice() {
          return {
            fontSize: [16, 16, 18],
            fontWeight: 400,
            pr: 1
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        cartHeaderOrderType: function cartHeaderOrderType() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderOrderType",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderOrderType"
          };
        },
        cartHeaderLocationName: function cartHeaderLocationName() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderLocationName",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderLocationName"
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: 18,
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "sm",
          fontWeight: 300,
          lineHeight: 4
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600
        },
        allLocationsSelectText: {
          fontSize: 20,
          fontWeight: 600
        },
        allLocationsText: function allLocationsText(_ref31) {
          var isLocationSearchPage = _ref31.isLocationSearchPage;
          return {
            fontSize: 20,
            color: isLocationSearchPage ? "#020001" : "#2A2C25",
            fontWeight: 600,
            fontFamily: "Montserrat-Bold"
          };
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 400
        },
        menuListTextCTA: {
          fontWeight: 400,
          fontSize: [10, 10, 14, 14, 14]
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 14],
          fontWeight: 200,
          pl: 1
        },
        cartItemRemoveText: {
          fontSize: "xs",
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 500
        },
        pdfMenuButtonText: {
          my: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: function locationListRestaurantName(_ref32) {
          var isFromLocationSearch = _ref32.isFromLocationSearch;
          return {
            fontWeight: isFromLocationSearch ? 600 : 500,
            fontSize: isFromLocationSearch ? 18 : 16,
            lineHeight: 18,
            textAlign: "left",
            fontFamily: "Montserrat-Bold"
          };
        },
        locationListRestaurantDetails: function locationListRestaurantDetails(_ref33) {
          var isFromLocationSearch = _ref33.isFromLocationSearch;
          return {
            fontSize: isFromLocationSearch ? 14 : 12,
            _web: {
              width: isFromLocationSearch ? "100%" : "70%",
              lineHeight: "18px"
            },
            fontWeight: isFromLocationSearch ? 400 : 300,
            lineHeight: 14
          };
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "400"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#020001",
            fontSize: {
              base: 18,
              lg: 32
            },
            fontWeight: "700"
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#2A2C25",
            fontWeight: "300",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "red",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "500"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#485062",
            fontSize: {
              base: 14
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#485062"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "#485062",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem(_ref34) {
          var fromOrderHistory = _ref34.fromOrderHistory;
          return {
            fontSize: {
              base: 14,
              lg: fromOrderHistory ? 14 : 16
            }
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel(_ref35) {
          var fromOrderHistory = _ref35.fromOrderHistory;
          return {
            fontSize: {
              base: 18,
              lg: fromOrderHistory ? 18 : 23
            },
            color: fromOrderHistory ? "#485062" : "black",
            fontWeight: fromOrderHistory ? 300 : 600
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal(_ref36) {
          var fromOrderHistory = _ref36.fromOrderHistory;
          return {
            fontSize: {
              base: 18,
              lg: fromOrderHistory ? 18 : 23
            },
            color: fromOrderHistory ? "#485062" : "#303030",
            fontWeight: fromOrderHistory ? 300 : 600
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle(_ref37) {
          var fromOrderHistory = _ref37.fromOrderHistory;
          return {
            color: fromOrderHistory ? "#303030" : "black",
            fontSize: {
              base: 16,
              lg: fromOrderHistory ? 14 : 18
            }
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontSize: {
              base: 12,
              md: 18
            }
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontSize: {
              base: 12,
              md: 16
            }
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontSize: {
              base: 12,
              lg: 16
            }
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 12
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 8
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 1
            },
            _android: {
              py: 1
            },
            marginBottom: 1.5,
            fontSize: {
              base: 15,
              lg: 14
            }
          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 15,
              lg: 16
            },
            letterSpacing: -0.4,
            fontWeight: "400",
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "400",
            letterSpacing: -0.3
          };
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupRestNameTitle: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationPickupResAdd2: {
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end

        /* Restaurant Details Start */
        restaurantDetails_Parking_Text: {
          fontWeight: 400,
          fontSize: 14,
          color: "#2A2C25"
        },
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "restaurantInfoAddToFavouritiesTextColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: "2px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "500",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            fontSize: {
              base: "18px",
              lg: "32px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 5,
            my: 2.5,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 5,
                lg: 7
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "restaurantInfoAddressTextColor",
            color: "restaurantInfoAddressTextColor",
            marginRight: {
              lg: 16
            }
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref38) {
          var customMarginHorizontal = _ref38.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: [16],
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: "#404040"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#404040"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#54301A"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            color: "#606060",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref39) {
          var disabled = _ref39.disabled;
          return {
            color: "white",
            fontSize: "16px",
            fontWeight: "500",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontSize: {
              base: 16,
              lg: 20
            },
            // mb: 4,
            color: "restaurantHoursTextColor"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsTextColor",
            maxWidth: "45%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsTextColor",
            maxWidth: "55%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "45%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "55%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: {
              base: "#606060",
              lg: "#404040"
            },
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: {
              lg: 20,
              base: 16
            },
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: {
              lg: "restaurantAboutSectionBodyTextSecColor",
              base: "restaurantAboutSectionBodyTextColor"
            },
            paddingBottom: 4,
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            lineHeight: "5"
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontWeight: 500,
            fontSize: 14,
            color: {
              base: "orderFromHereButtonTextColor",
              lg: "amenitiesActionButtonsColor"
            },
            textAlign: "center",
            textTransform: "uppercase",
            _web: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            paddingBottom: 4,
            fontSize: {
              lg: 20,
              base: 16
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "12",
            lg: "14"
          },
          color: "#404040"
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#404040"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1,
          color: {
            base: "#020001",
            lg: "#404040"
          }
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "white",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            fontWeight: 500,
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "14px",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: {
              base: "uppercase",
              lg: "uppercase"
            }
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: "restaurantTimingWeekDayTextColor",
            fontSize: {
              base: "12",
              lg: "12"
            },
            position: "absolute"
          };
        },
        restaurantDetails_PoliteNotice_Title: function restaurantDetails_PoliteNotice_Title() {
          return {
            fontSize: 16,
            fontWeight: 400,
            mb: 5,
            color: "#2A2C25"
          };
        },
        restaurantDetails_PoliteNotice_Desc: function restaurantDetails_PoliteNotice_Desc() {
          return {
            fontSize: 14,
            fontWeight: 200,
            color: "#404040",
            lineHeight: 5
          };
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },

        /* Restaurant Details End */
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor",
            textTransform: "uppercase"
          };
        },

        /* Order Tracking start*/
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5,
          color: "#485062"
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "#485062",
            fontWeight: 400,
            fontSize: 20,
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: 12,
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: 16,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          };
        },
        orderStatusCurbsideCheckInButtonText: function orderStatusCurbsideCheckInButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInButton"
          };
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        checkText: function checkText() {
          return {
            fontSize: 14,
            fontWeight: 300,
            lineHeight: 4,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 4,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: 12,
            lineHeight: 4,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: 16,
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary",
            textTransform: "uppercase"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: 16,
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary",
            textTransform: "uppercase"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "#485062",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#79818C",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "#2A2C25",
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400,
          color: "#2A2C25"
        },

        /* Order Tracking end*/
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        scrollingNavigationCarouselItemText: function scrollingNavigationCarouselItemText(_ref40) {
          var isActive = _ref40.isActive;
          return {
            fontWeight: isActive ? 400 : 300
          };
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: {
              base: "Montserrat-Light",
              md: "Montserrat-Regular"
            },
            color: "#020001",
            fontSize: 14
          };
        },
        increaseTextSize: function increaseTextSize(_ref41) {
          var styleSize = _ref41.styleSize;
          return {
            fontSize: styleSize
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        myReservationCardBottomControlsText: function myReservationCardBottomControlsText() {
          return {};
        },
        quantityText: function quantityText() {
          return {
            fontFamily: "Montserrat-Regular",
            fontSize: {
              base: "xs",
              md: "lg"
            },
            fontWeight: 300,
            lineHeight: {
              base: 4,
              md: 5
            },
            letterSpacing: -0.3
          };
        },
        reservationListCardCtaText: function reservationListCardCtaText() {
          return {
            pl: 2,
            fontWeight: 500,
            fontSize: 14,
            color: "#020001",
            lineHeight: 5
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            fontSize: 12,
            color: "#020001",
            lineHeight: 5
          };
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 400,
            fontSize: 11,
            color: "#303030",
            lineHeight: 5
          };
        },

        /** Text: Private Dining Start */
        privateDiningLocationModalHeaderText: {
          color: "#FFFFFF",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        privateDiningFilterStateHeading: {
          fontSize: 20,
          color: "#020001",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        pd_requestFlow_form_title: function pd_requestFlow_form_title() {
          return {
            pt: {
              base: 5,
              md: 6
            },
            pb: {
              base: 4,
              md: 6
            },
            fontSize: {
              base: 16,
              md: 22
            },
            lineHeight: 6,
            textAlign: "center",
            fontFamily: "Montserrat-Regular",
            color: "#FFFFFF"
          };
        },
        pd_requestFlow_form_tabIndex: function pd_requestFlow_form_tabIndex(_ref42) {
          var isActive = _ref42.isActive;
          return {
            m: "auto",
            color: isActive ? "#292D36" : "#CBD1D6",
            fontSize: {
              base: "xs",
              md: "md"
            }
          };
        },
        pd_requestFlow_form_tabTitle: function pd_requestFlow_form_tabTitle(_ref43) {
          var isActive = _ref43.isActive,
              isCompleted = _ref43.isCompleted;
          return {
            fontWeight: isActive ? 400 : 200,
            fontSize: {
              base: "sm",
              md: "md"
            },
            color: isActive || isCompleted ? "#FFFFFF" : "#787D88"
          };
        },
        pd_request_eventDetails_locationTitle: {
          fontSize: {
            base: "sm",
            md: "md"
          },
          fontWeight: 400,
          mb: 1.5,
          color: "#020001"
        },
        pd_request_eventDetails_locationAddress: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          lineHeight: 4,
          color: "#020001"
        },
        pd_request_eventDetails_locationPhoneNum: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          color: "#020001"
        },
        pd_request_eventDetails_locationChange: {
          fontSize: 12,
          fontWeight: 300,
          color: "#485062"
        },
        pd_request_eventDetails_InputTitle: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          mb: 2,
          color: "#303030"
        },
        pd_request_eventDetails_noOfGuest_subMessage: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          mt: 2
        },
        pd_request_eventDetails_splRequestTitle: {
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 4,
          mr: 3
        },
        pd_request_contactDetails_InputTitle: {
          color: "#303030",
          fontSize: 14,
          mb: 2,
          fontFamily: "Montserrat-Regular"
        },
        pd_request_contactDetails_InputTitl_Optional_text: {
          color: "#606060",
          fontSize: 14,
          mb: 2,
          fontFamily: "Montserrat-Regular"
        },
        pd_review_details_diresctions_text: {
          fontWeight: 500,
          fontSize: 14
        },
        pd_request_contactDetails_dobTitle: {
          color: "#303030",
          fontSize: 16,
          mr: 2,
          fontFamily: "Montserrat-Regular"
        },
        pd_request_contactDetails_dobTooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Montserrat-Regular"
        },
        pd_request_eventDetails_dineInDate_tooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Montserrat-Regular"
        },
        pd_contactDetails_userInfoName: {
          color: "#303030",
          fontFamily: "Montserrat-Medium",
          fontWeight: 500,
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 2
        },
        pd_contactDetails_userInfoExtras: {
          color: "#303030",
          fontFamily: "Montserrat-Regular",
          fontSize: {
            base: 12,
            md: 14
          },
          _ios: {
            lineHeight: 14
          },
          _android: {
            lineHeight: 14
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetails_title: {
          color: "#606060",
          fontFamily: "Montserrat-Regular",
          fontSize: 12
        },
        pd_reveiwDetails_restName: {
          color: "#303030",
          fontFamily: "Montserrat-Medium",
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 1
        },
        pd_reviewDetails_restAddress: {
          color: "#020001",
          fontFamily: "Montserrat-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_restPhoneNum: {
          color: "#020001",
          fontFamily: "Montserrat-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_eventInfoTitle: {
          color: "#606060",
          fontFamily: "Montserrat-Regular",
          fontSize: 12,
          _web: {
            lineHeight: 12
          },
          mb: 2
        },
        pd_reviewDetails_eventInfoData: {
          color: "#2C303B",
          fontFamily: "Montserrat-Regular",
          fontSize: {
            base: 14,
            md: 16
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetailsSplReqTitle: function pd_reviewDetailsSplReqTitle(_ref44) {
          var isFromConfirmation = _ref44.isFromConfirmation;
          return {
            color: isFromConfirmation ? "#606060" : "#303030",
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 15,
            fontFamily: "Montserrat-Regular",
            mb: 2
          };
        },
        pd_reviewDetailsSplReqData: function pd_reviewDetailsSplReqData(_ref45) {
          var isFromConfirmation = _ref45.isFromConfirmation;
          return {
            color: isFromConfirmation ? "#303030" : "#606060",
            fontSize: 14,
            fontFamily: "Montserrat-Regular",
            fontWeight: 400
          };
        },
        pd_confirmation_title: {
          color: "#485062",
          fontSize: 16,
          maxW: {
            md: "354px"
          },
          textAlign: "center",
          fontWeight: 600
        },
        pd_confirmation_emailText: {
          color: "#505050",
          fontFamily: "Montserrat-Regular",
          fontSize: 14
        },
        pd_confirmation_email: {
          color: "#485062",
          textAlign: "center",
          fontSize: 14,
          mt: 1
        },
        pd_confirmation_salesMessage: {
          color: "#505050",
          fontFamily: "Montserrat-Regular",
          fontSize: 14,
          maxW: {
            md: "387px"
          },
          textAlign: "center"
        },
        pd_confirmation_restPhoneNum: {
          color: "#485062",
          fontSize: 14,
          fontFamily: "Montserrat-Medium",
          fontWeight: 400
        },
        pd_cancelModalMessage: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#606060",
          fontFamily: "Montserrat-Regular"
        },
        pd_cancelModalCancelCTAText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#485062",
          fontFamily: "Montserrat-Regular"
        },
        pd_cancelModalCancelConfirmText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#FFFFFF",
          fontFamily: "Montserrat-Regular"
        },
        pd_request_eventDetails_dineInDate_subMessage: {
          fontSize: "xs",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          fontFamily: "Montserrat-Regular",
          mr: 2
        },
        pd_landing_home_subText: {
          color: "#404040",
          fontWeight: 300
        },
        pd_landing_home_activeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: 22,
            md: 45
          },
          fontWeight: 500,
          fontFamily: "Montserrat-Medium"
        },
        pd_landing_stickyContainer_label: {
          fontSize: {
            base: "xs",
            md: "md"
          },
          fontWeight: 300,
          color: "#404040",
          lineHeight: 5,
          textAlign: {
            base: "center",
            md: "start"
          },
          mt: {
            base: 1,
            lg: 0
          },
          maxWidth: {
            base: 80,
            md: "360px"
          },
          wordBreak: "break-word"
        },
        pd_landing_makeAReq_ctaText: {
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: {
            base: "sm",
            md: "xl"
          },
          lineHeight: 6
        },
        pd_landing_menuTabs_itemLabel: function pd_landing_menuTabs_itemLabel(_ref46) {
          var isActive = _ref46.isActive;
          return {
            textTransform: "uppercase",
            color: isActive ? "#FFFFFF" : "#485062",
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 6,
            fontFamily: "Montserrat-Medium"
          };
        },
        pd_landing_dropdown_activeLable: function pd_landing_dropdown_activeLable(_ref47) {
          var isActive = _ref47.isActive;
          return {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 6,
            color: isActive ? "#485062" : "#FFFFFF",
            textTransform: "uppercase",
            fontFamily: "Montserrat-Medium"
          };
        },
        pd_landing_locationHeaderName: {
          pb: 1,
          fontSize: 16,
          fontWeight: 300,
          color: "#404040",
          textTransform: "capitalize"
        },
        pd_landing_locationHeaderChangeLoc: {
          fontSize: 16,
          color: "#485062",
          fontWeight: 600,
          textTransform: "capitalize",
          fontFamily: "Montserrat-Medium"
        },
        pd_landing_floorPlanLink_text: {
          textAlign: "center",
          mt: 3,
          fontSize: 14,
          fontWeight: 300,
          color: "#485062"
        },
        pd_landing_floorPlan_viewGalleryLink: {
          color: "#485062",
          fontSize: {
            base: 14,
            lg: 20
          },
          fontWeight: 500,
          fontFamily: "Montserrat-Medium"
        },
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: 400
        },
        reorderNonLoggedInText: {
          fontSize: 16,
          fontWeight: 500
        },
        reservationCheckboxText: {
          fontWeight: 300
        },
        reservationStaticLinkText: {
          fontWeight: 500,
          color: "primary.100"
        },
        sectionHeaderLongDescription: {
          fontSize: ["sm", "sm", "md"],
          color: "categoriesHeadingColor"
        },

        /** Text: Private Dining End */
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "#4E311D",
          fontSize: 24,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "#4E311D",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 200,
          color: "#4E311D",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "12"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "12"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        myAccountDOBPrevText: function myAccountDOBPrevText(_ref48) {
          var prevMonthButtonDisabled = _ref48.prevMonthButtonDisabled;
          return {
            mr: "auto",
            fontSize: 12,
            color: prevMonthButtonDisabled ? "transparent" : "#4E311D",
            textTransform: "capitalize"
          };
        },
        myAccountDOBNextText: function myAccountDOBNextText(_ref49) {
          var nextMonthButtonDisabled = _ref49.nextMonthButtonDisabled;
          return {
            ml: "auto",
            fontSize: 12,
            color: nextMonthButtonDisabled ? "transparent" : "#4E311D",
            textTransform: "capitalize"
          };
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 200,
          color: "#485062",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "secondary.300",
          textAlign: "center",
          fontSize: 16
        },
        eclub_selected_restaurant_name: {
          fontWeight: 400
        },
        eclub_changeLocationCTAText: {
          fontWeight: 400
        },
        reservationSeatingOptionText: {},
        myAccount_mobileHeader_text: {
          color: "#FFFFFF",
          fontSize: 18,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal"
        },
        order_history_details_order_number_text: {
          color: "#485062"
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "#606060",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 500
        },
        orderHistory_reorderText: {
          color: "#485062",
          fontSize: 16,
          fontWeight: 400
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "400",
          color: "white",
          letterSpacing: "0.31"
        },
        joinEClubHeading: {
          fontWeight: 500,
          textAlign: "center",
          color: "#485062",
          fontSize: {
            base: 24,
            md: 32
          },
          width: {
            base: "80%",
            md: "60%"
          },
          lineHeight: 8,
          fontFamily: "Montserrat-Regular"
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "#485062",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        // My Account
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400,
          color: "#485062"
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountChangeLocationChangeText: {
          color: "#485062",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400,
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          }
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#2A2C25"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subText: {
          marginTop: 1,
          fontSize: 12,
          lineHeight: 4,
          color: "#808080",
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "#808080"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          paddingTop: 4,
          paddingBottom: 3,
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#2A2C25"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#000",
          fontSize: 20,
          fontWeight: 400
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "themeGrey"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "backLinkColor"
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 10,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 12,
          color: "#485062"
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#8E774D"
          },
          letterSpacing: -0.3,
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            fontSize: {
              base: "12px",
              md: "13px"
            },
            fontWeight: 200,
            color: {
              base: "#606060",
              md: "#303030"
            }
          },
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#FFFFFF"
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400,
          mb: 6
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#303030",
          fontWeight: 200,
          mb: 2
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5,
          color: "#485062"
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 0
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          fontWeight: 200,
          color: "#606060",
          textAlign: "center"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          color: "profileAddCardButtonText",
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          _web: {
            textTransform: "uppercase",
            color: "#fff"
          }
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor",
          textTransform: "uppercase"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          flex: 1,
          color: "#FFFFFF"
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#FFFFFF",
          fontWeight: 300
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          fontSize: 16,
          _web: {
            marginTop: 2,
            marginBottom: 2
          },
          lineHeight: 5,
          textAlign: "center",
          color: "#485062",
          fontWeight: 300
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 400,
          color: "themeGrey",
          py: 2
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          marginY: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 16,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#FFFFFF",
          _web: {
            mt: {
              base: 5,
              md: 3
            },
            mb: {
              base: 3,
              md: 2
            }
          },
          fontWeight: 300
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          },
          color: "#FFFFFF"
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "reorderInfoTextColor"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 14,
          fontWeight: 300,
          color: "#303030",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          }
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "#808080"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: -0.6,
          mt: 1,
          color: "#303030"
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "#606060"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "#808080",
          mb: 1
        },
        order_history_details_pickup_time_desc: {
          mt: 0,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "#303030"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          mb: 2
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 26,
          color: "#485062"
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 300,
          fontSize: 18
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 18,
          fontWeight: 400
        },
        // My Account ends
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 20,
          fontWeight: 400,
          my: 3,
          textAlign: "center",
          letterSpacing: "-0.1",
          color: "#303030"
        },
        myAccountConfirmationHeadSubText: {
          color: "#808080",
          fontSize: 16,
          fontWeight: 300,
          my: 2,
          textAlign: "center",
          lineHeight: 5,
          maxWidth: 337
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#fff"
        },
        eclubSecondarySubsCheckbox: {
          mt: {
            base: -1,
            md: 0
          }
        },
        editProfileFullBottomButtonText: {
          fontSize: 16
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {},
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 16,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase"
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 400
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor"
        },
        dateTimePickerModalTitle: {
          display: "none"
        }
      }
    },
    HStack: {
      variants: {
        /* RESERVATION */
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#292C33",
            bg: "#292C33"
          };
        },
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "center",
          alignItems: "center",
          mr: 1,
          flex: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          pl: 2,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref50) {
          var isError = _ref50.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#F0FFFF",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 4
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 0,
          shadow: 10,
          bg: "#E9EAEC"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#48506233",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 0,
          shadow: 10,
          bg: {
            base: "#E9EAEC",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4
          },
          my: 3,
          bg: "#E9EAEC"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref51) {
          var isSelected = _ref51.isSelected;
          return {
            bg: "#E5E5E5",
            borderWidth: isSelected ? 0 : 1,
            borderColor: "themeSectionSeparator",
            borderRadius: isSelected ? 0 : 13,
            shadow: 5,
            overflow: "hidden"
          };
        },
        cartItemButtonsContainer: function cartItemButtonsContainer() {
          return {
            justifyContent: "space-between"
          };
        },
        //Restaurant Details
        restaurantDetails_Parking_Inner_Container: {
          _web: {
            px: "14px",
            py: 3
          },
          alignItems: "center",
          bg: "#EEF0F1"
        },
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "#E9EAEC",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        borderRadiusValue: function borderRadiusValue(_ref52) {
          var radiusValue = _ref52.radiusValue,
              topRadiusValue = _ref52.topRadiusValue,
              bottomRadiusValue = _ref52.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        },

        /* HStack: Private Dining Start */
        pd_Header_Container: function pd_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            bgColor: "#292C33"
          };
        },
        privateDiningLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#48506233",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        pd_request_eventDetails_selectTime_container: {
          marginTop: 2,
          marginBottom: 1,
          marginX: 5,
          borderColor: "#48506233",
          borderWidth: 1,
          paddingY: 4,
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 0
        },
        pd_request_contactDetails_userInfo: {
          p: 4,
          bg: "#E9EAEC"
        },
        pd_request_eventDetails_inputContainer: function pd_request_eventDetails_inputContainer(_ref53) {
          var errorMessage = _ref53.errorMessage,
              isActive = _ref53.isActive;
          return {
            py: 4,
            px: 3,
            alignItems: "center",
            borderRadius: 0,
            borderColor: errorMessage ? "#D30000" : isActive ? "#485062" : "transparent",
            borderWidth: 1,
            bgColor: "#E9EAEC"
          };
        },
        pd_landing_menuTabs_container: {
          alignItems: "center",
          justifyContent: "space-between",
          flex: 0.7
        },
        pd_landing_menuDropdown_summary: function pd_landing_menuDropdown_summary(_ref54) {
          var isExpanded = _ref54.isExpanded;
          return {
            p: 5,
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottomColor: isExpanded ? "#B7BEC5" : "transparent",
            borderBottomWidth: 1,
            fontFamily: "Montserrat-Medium"
          };
        },
        pd_landing_floorPlanLinksSection: {
          bgColor: {
            lg: "#B7BEC5"
          },
          py: {
            lg: 5
          },
          alignItems: "center",
          justifyContent: "center"
        },

        /* HStack: Private Dining End */
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "#F2EEEA",
          zIndex: 1
        },
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "#B8C0C7",
          alignItems: "center",
          mb: 2
        },
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 0,
          borderColor: "#E9EAEC",
          borderWidth: 1,
          bg: "#E9EAEC"
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 5
          },
          backgroundColor: {
            base: "#E9EAEC",
            md: "#E9EAEC"
          },
          borderRadius: 0,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          },
          alignItems: "flex-start"
        }
      }
    },
    Image: {
      variants: {
        pdRequestPageBg: {
          display: "inherit"
        },
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          rounded: "md",
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 8,
        //Restaurant Details
        restaurantDetails_Parking_Image: {
          w: "47px",
          h: "47px"
        },
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref55) {
          var radiusValue = _ref55.radiusValue,
              topRadiusValue = _ref55.topRadiusValue,
              bottomRadiusValue = _ref55.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref56) {
          var active = _ref56.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        },
        pd_select_restaurant_brand_logo: {
          height: "32px",
          width: "138px"
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          position: "relative",
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 8
        },

        /** VStack: Private Dining Start */
        pd_requestForm_Tabs_Container: {
          bgColor: "#292D36"
        }
        /** VStack: Private Dining End */

      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 0
        },

        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          flex: 1,
          alignItems: "flex-start"
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 0
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 0,
          my: 6,
          py: 5
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 9,
          bg: "#E9EAEC",
          _web: {
            pb: 9
          },
          borderRadius: 0
        },
        reservationProfileContactDetailsBox: {
          py: 3,
          flex: 1,
          my: 3
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          _web: {
            bg: {
              base: "reservationBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            }
          }
        },
        reservationDropdownRadius: 0,
        appMessagesSuccessDialogBorderRadius: 0,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#B7BEC5",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 0,
          _ios: {
            width: 32,
            height: 12
          },
          _android: {
            width: 32,
            height: 12
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 0,
          bg: "#E9EAEC"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref57) {
          var isActive = _ref57.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "reservationBg" : "#292D36"
          };
        },

        /*RESERVATION*/
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Montserrat-Medium"
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#A9AD00",
          px: 9,
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 0,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref58) {
          var hasSub = _ref58.hasSub;
          return {
            mb: {
              base: hasSub && -1,
              md: hasSub && -4
            }
          };
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: {
              base: "Montserrat-Light",
              md: "Montserrat-Regular"
            },
            color: "#020001",
            _web: {
              fontSize: {
                base: "13px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        menuItemDesciption: function menuItemDesciption() {
          return {
            color: "#303030",
            fontWeight: 400,
            fontSize: 14,
            fontFamily: "Montserrat-Regular",
            textDecoration: "none"
          };
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "393px",
                md: "413px"
              },
              pb: 10
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        pdfMenuButtonContainer: {
          _web: {
            my: 3
          }
        },
        tempDescriptionBox: function tempDescriptionBox(_ref59) {
          var isChild = _ref59.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 0,
            borderRightRadius: 0,
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 0,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: function locationCard(_ref60) {
          var isFromLocationSearchPage = _ref60.isFromLocationSearchPage;
          return {
            borderBottomWidth: 1,
            borderWidth: {
              base: 0,
              md: 1
            },
            borderColor: isFromLocationSearchPage ? "allLocationsPageItemBoxBorderColor" : "allLocationsItemBoxBorderColor",
            borderRadius: 0,
            p: {
              base: 0,
              md: 1
            },
            mt: {
              base: 0,
              md: 4
            },
            mr: {
              base: 0,
              md: isFromLocationSearchPage ? "2%" : 8
            },
            _web: {
              minWidth: {
                base: "100%",
                md: "300px"
              }
            },
            width: isFromLocationSearchPage ? "48%" : "40%",
            bg: isFromLocationSearchPage ? "allLocationsBodyBgDesktop" : "locationCardBg"
          };
        },
        listCard: {
          borderRadius: 0,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 6
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0.5
          };
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            bg: "#E9EAEC",
            width: "100%",
            pt: 4,
            pb: 8,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref61) {
          var isMobile = _ref61.isMobile;
          return {
            borderRadius: 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Parking_Outer_Container: {
          px: {
            base: -6,
            lg: 6
          },
          mt: "6"
        },
        restaurantDetails_Parking_Image_Container: {
          bg: "#B3BAC0",
          rounded: "full",
          _web: {
            mr: "14px"
          },
          overflow: "hidden"
        },
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref62) {
          var hideWaitlistSection = _ref62.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref63) {
          var isSticky = _ref63.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref64) {
          var isMobile = _ref64.isMobile,
              singleActionButton = _ref64.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 3
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#D27D1E"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref65) {
          var isInStack = _ref65.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          shadow: 11,
          mr: "8"
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "restaurantDetailsBGColor"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#B7BEC5"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#B7BEC5"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#525967"
        },
        //Restaurant Details end
        //Location search
        tabLocationsTopWidth: 0,
        // location search page
        locationSearchActiveTab: function locationSearchActiveTab(_ref66) {
          var isActive = _ref66.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref67) {
          var radiusValue = _ref67.radiusValue,
              topRadiusValue = _ref67.topRadiusValue,
              bottomRadiusValue = _ref67.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref68) {
          var isSmallScreen = _ref68.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 12
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref69) {
          var isIOS = _ref69.isIOS;
          return {
            _text: {
              color: "white",
              pt: isIOS ? 1 : 0,
              fontSize: 12
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        smartRecommendationModalHeadingContainer: {
          flex: 1
        },

        /** Box: Private Dining Start */
        privateDiningDropdownRadius: 0,
        privateDiningLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        privateDiningLocationDropdownBox: {
          bg: "#B7BEC5",
          h: {
            base: "72px",
            md: "82px"
          },
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        pd_makeRequest_container: {
          width: {
            base: "100%",
            md: "794"
          },
          m: {
            md: "auto"
          },
          my: {
            md: 6
          },
          minH: {
            md: "543"
          },
          bg: "#CBD1D6",
          shadow: {
            md: 10
          }
        },
        pd_requestFlow_form_tabActiveBorder: function pd_requestFlow_form_tabActiveBorder(_ref70) {
          var isActive = _ref70.isActive;
          return {
            mt: {
              base: 3,
              md: 4
            },
            height: 1,
            bgColor: isActive ? "requestFormTabActiveItem" : "transparent",
            w: "100%",
            borderTopRadius: 0
          };
        },
        pd_request_eventDetails_locationDetails: {
          py: {
            base: 3,
            md: 4
          },
          px: {
            base: 3,
            md: 4
          },
          bgColor: "#E9EAEC"
        },
        pd_actionSheetBorderRadius: 0,
        pd_reviewDetails_container: {
          borderRadius: 0,
          p: 4,
          bg: "#E9EAEC"
        },
        pd_confirmationText_Container: {
          rounded: 0,
          border: 0,
          borderColor: "transparent",
          py: 5,
          px: {
            base: 4,
            md: "56px"
          },
          bg: "#E9EAEC",
          alignItems: "center"
        },
        pd_reviewDetails_messageRegardingRequest: {
          display: "none"
        },
        pd_request_contactDetails_specialReq: {
          mt: 5
        },
        pd_landing_eventGuideContainer: {
          display: "none"
        },
        pd_landing_menuDropdown: function pd_landing_menuDropdown(_ref71) {
          var isExpanded = _ref71.isExpanded;
          return {
            p: 0,
            bgColor: isExpanded ? "#E9EAEC" : "#292D36",
            _hover: {
              bg: isExpanded ? "#FFFFFF" : "#292D36"
            },
            _expanded: {
              bg: isExpanded ? "#FFFFFF" : "#292D36"
            }
          };
        },
        pd_requestFlow_form_tabBG: function pd_requestFlow_form_tabBG(_ref72) {
          var isActive = _ref72.isActive;
          return {
            bgColor: isActive ? "requestFormTabActiveItem" : "requestFormTabDisableItem"
          };
        },

        /** Box: Private Dining End */
        eClubSignUpBox: {
          bg: "#E8EAEC",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center"
        },
        eClubNewsBox: {
          borderRadius: 10,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          alignItems: "center"
        },
        eClub_Building_Box: {
          w: "100%",
          h: 600,
          bg: "#CBD1D6"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        myAccount_editFields_actionSheet_webBox: {
          pt: 2,
          pb: 7,
          bg: "#CBD1D6"
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#B7BEC5",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#B7BEC5",
          accessible: false,
          _web: {
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref73) {
          var radiusValue = _ref73.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(91.85deg, #485062 0%, #808080 100%)"
              }
            },
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0,
            pt: 1
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            height: "100%",
            overflowY: "auto",
            backgroundColor: {
              base: "#CBD1D6",
              md: "transparent"
            }
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 3,
          paddingBottom: 4,
          justifyContent: "center",
          bg: "#E9EAEC"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center",
          bg: "mobileOrderHistoryBackgroundColor"
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "#CBD1D6"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 56,
          width: 80,
          _web: {
            height: "53px",
            width: "76px"
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 700,
          overflow: "clip",
          rounded: 0,
          bg: "#CBD1D6",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#B7BEC5"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#B7BEC5",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          mb: {
            base: 8,
            md: 2
          },
          paddingY: 5,
          bg: {
            base: "#CBD1D6",
            md: "#CBD1D6"
          }
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 0,
          overflow: "hidden",
          shadow: 3
        },
        myAccount_paymentOptions_container: {
          marginBottom: 5,
          py: 1,
          backgroundColor: "white",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%",
            bg: {
              base: "myAccountScreenBackroundColor",
              md: "#CBD1D6"
            },
            my: {
              base: 0,
              md: 0
            }
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#54301A",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 12,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "#B7C0C7",
          borderBottomWidth: 1,
          borderColor: "#B7C0C7",
          _web: {
            marginX: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          borderRadius: 0,
          py: 2,
          px: 3
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          },
          bg: "#292D36"
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 5,
          _web: {
            width: {
              base: "100%",
              md: "60%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          }
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          w: "100%",
          bg: "#292D36"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between",
          bg: "#CBD1D6"
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0,
          bg: "#CBD1D6"
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: 5,
          alignItems: "flex-start",
          justifyContent: "center"
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "#E9EAEC",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            paddingY: 1
          },
          _ios: {
            marginTop: 6
          },
          paddingX: 5,
          alignItems: "center",
          _web: {
            bg: {
              base: "#CBD1D6",
              md: "#E9EAEC"
            },
            py: {
              base: 5,
              md: 4
            },
            alignItems: {
              md: "flex-end"
            },
            px: {
              md: 12
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          },
          color: "#292D36"
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 4,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: {
            base: "#E9EAEC",
            md: "displayImageFallbackBackground"
          }
        },
        // My Account ends,
        mobileGiftCardBrandLogo: {
          height: 35,
          width: 57
        },
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4,
          _android: {
            bgColor: "editProfileScreensBackgroundColor"
          },
          _ios: {
            bgColor: "editProfileScreensBackgroundColor"
          }
        },
        paymentOptions_giftCardLarge_deleteCTA: {},
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            backgroundColor: "transparent",
            height: "100%"
          }
        },
        eClubBGGradient_box: {// empty
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: "none"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref74) {
          var radiusValue = _ref74.radiusValue,
              topRadiusValue = _ref74.topRadiusValue,
              bottomRadiusValue = _ref74.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 0,
          backgroundColor: "#F5F0E7"
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          paddingX: 3,
          marginRight: 3,
          bgColor: "mobilePaymentMethodIconBg"
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref75) {
          var isMobile = _ref75.isMobile;
          return {
            bg: "#E9EAEC",
            rounded: 0,
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#CCD1D5",
          rounded: 0,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref76) {
          var radiusValue = _ref76.radiusValue,
              topRadiusValue = _ref76.topRadiusValue,
              bottomRadiusValue = _ref76.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref77) {
          var radiusValue = _ref77.radiusValue,
              topRadiusValue = _ref77.topRadiusValue,
              bottomRadiusValue = _ref77.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {},
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "#292D36"
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "#292D36"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0,
          bg: "#292D36"
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref78) {
          var radiusValue = _ref78.radiusValue;
          return {
            borderRadius: radiusValue
          };
        },

        /** PopoverContent: Private Dining Start */
        pd_request_eventDetails_purposDropdown: {
          top: {
            md: 20
          },
          bg: "#E9EAEC",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4",
          shadow: 15
        },
        pd_request_eventDetails_timeDropdown: {
          bg: "#E9EAEC",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          shadow: 10,
          borderColor: "transparent"
        },
        pd_request_eventDetails_partySizeDropdown: {
          bg: "#E9EAEC",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "transparent",
          shadow: 15
        },
        pd_request_eventDetails_menuPrefDropdown: {
          top: {
            md: 20
          },
          bg: "#E9EAEC",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "transparent",
          shadow: 15
        },
        pd_request_contactDetails_dopTooltip: {
          backgroundColor: "#6B7280",
          borderRadius: 0
        },
        pd_request_contactDetails_phoneType: {
          borderRadius: 0,
          py: 6,
          px: 4,
          bg: "#E9EAEC",
          top: 2,
          shadow: 13,
          border: "none"
        }
        /** PopoverContent: Private Dining End */

      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref79) {
          var radiusValue = _ref79.radiusValue,
              topRadiusValue = _ref79.topRadiusValue,
              bottomRadiusValue = _ref79.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%"
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#BBBBBB",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Checkbox: {
      variants: {
        eclub_restaurantOptions: {
          alignItems: "flex-start"
        }
      }
    }
  },
  fontConfig: {
    Montserrat: {
      100: {
        normal: "Montserrat-Light"
      },
      200: {
        normal: "Montserrat-Light"
      },
      300: {
        normal: "Montserrat-Regular"
      },
      400: {
        normal: "Montserrat-Medium"
      },
      500: {
        normal: "Montserrat-Bold"
      },
      600: {
        normal: "Montserrat-ExtraBold"
      },
      700: {
        normal: "Montserrat-ExtraBold"
      }
    },
    Lato: {
      100: {
        normal: "Lato-Light",
        italic: "Lato-Light"
      },
      200: {
        normal: "Lato-Regular",
        italic: "Lato-Regular"
      },
      300: {
        normal: "Lato-Bold",
        italic: "Lato-Bold"
      }
    }
  },
  fonts: {
    heading: "Montserrat",
    body: "Montserrat",
    headingSecondary: "Montserrat",
    youMightLikeText: "Montserrat-Bold"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));